var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm7.874-23.07a.375.375 0 01.09.172c.028.114.04.231.035.348 0 .063-.006.123-.012.194-.004.045-.008.093-.011.149-.094 1.503-2.903 12.727-2.903 12.727a.898.898 0 01-.77.68 1.113 1.113 0 01-.807-.308c-.634-.543-2.105-1.578-3.471-2.515a33.732 33.732 0 00-2.09 1.898c-1.207 1.199-1.052 0-1.052 0l.371-3.851a.145.145 0 01.053-.129l.126-.112c.954-.846 7.004-6.215 7.179-6.823.015-.055-.042-.077-.115-.055-.476.173-8.665 5.307-9.569 5.874a.435.435 0 01-.201.011l-3.975-1.285s-.474-.188-.322-.624c.032-.09.096-.166.285-.297.88-.61 16.3-6.11 16.3-6.11a1.33 1.33 0 01.694-.049c.063.02.12.056.165.104z",
    fill: "#fff"
  })));
}
export default SvgTelegramIcon;